import React from 'react';
import { motion } from 'framer-motion';
import { judgmentSteps } from '../../data/home';
import { easeOutStrong, fadeUp } from '../../utils/motion';
export function HomeJudgmentFlow() {
  return <section className="bg-navy text-white py-20 lg:py-28" data-id="element-427" data-mp="321houixt1ht5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-428" data-mp="32319smueoh19">
        <motion.h2 {...fadeUp} className="font-heading font-bold text-4xl lg:text-5xl tracking-tight max-w-2xl mb-16" data-id="element-429" data-mp="370uax1guqkuo">
          From knowledge to better judgment
        </motion.h2>

        <div className="relative" data-id="element-430" data-mp="2lbef375e0bh">
          <div aria-hidden="true" className="hidden md:block absolute top-[7px] left-0 right-0 h-px bg-white/25" data-id="element-431" data-mp="3kzu1ienxd9th" />
        <ol className="relative grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-10" data-id="element-432" data-mp="3pxm3y2m74ebx">
          {judgmentSteps.map((step, index) => <motion.li key={step.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.3,
            delay: index * 0.06,
            ease: easeOutStrong
          }} className="relative" data-id="element-433" data-mp="hh0qo9mj6z30" data-mpi={index}>
              <span className="relative block w-[15px] h-[15px] rounded-full bg-navy border-2 border-green-soft mb-8" data-id="element-434" data-mp="2qvp0kcoa907m" />
              <h3 className="font-heading font-bold text-2xl mb-3" data-id="element-435" data-mp="2m3x79udqsgds">{step.title}</h3>
              <p className="text-white/75 text-lg leading-relaxed" data-id="element-436" data-mp="30stooi1ov5r2">{step.body}</p>
            </motion.li>)}
        </ol>
        </div>
      </div>
    </section>;
}